import axios from "axios";
import { baseURL, oauthPrefix } from './Config'

function uploadFile(file, bucket, callback, errorCallback){
    let url = "/manage/uploadFile"
    var bodyForm = new FormData()
    bodyForm.append("file", file)
    bodyForm.append("bucket", bucket)

    axios.post(url, bodyForm,{
        baseURL: baseURL,
        headers:{
            "content-type": "multipart/form-data",
            "Authorization": oauthPrefix + localStorage.getItem("access_token")
        }
    })
    .then((response)=>{
        console.log(response)
        callback(response.data.link)
    })
    .catch((error)=>{
        errorCallback(error)
    })

}

export {
    uploadFile
}